import React from 'react';
import { Row, Col, Label } from 'reactstrap';
import Highlighter from '../Common/Inputs/Highlighter';
import { Loading } from './../Common/Loading';
import Constants from '../../Constants';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

class SelectSearchChecboxOptions extends React.Component {
  state = {
    searchTerm: '',
  };

  checkOrgs = (inputFields, obj) => {
    this.props.clientIdsSelectedEvent(inputFields, obj.id);
  };

  filterItems(arr, query) {
    return arr.filter(function (el) {
      return query ? el.name.toLowerCase().indexOf(query.toLowerCase()) > -1 : true;
    });
  }

  renderOptions() {
    const inputFields = this.props;
    const searchTerm = this.state.searchTerm || '';
    const options = this.filterItems(inputFields.dataObj || [], searchTerm).map((obj, index) => {
      const checkIndex = inputFields.clientIdsSelected?.indexOf(obj.id);
      return (
        <div key={`check_option_report_org_${obj.id}`}>
          <span
            tabIndex="0"
            role="checkbox"
            aria-checked={checkIndex !== -1}
            aria-label={obj.name}
            onClick={() => this.checkOrgs(inputFields, obj)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                this.checkOrgs(inputFields, obj);
              }
            }}
            className={
              'list-item display-flex ' +
              (checkIndex !== -1
                ? 'selectedCheckbox'
                : inputFields.clientIdsSelected.length === inputFields.maxAllowed
                ? 'disabledSeachCheck'
                : 'unSelectCheckbox')
            }>
            <i className={'checkBox far ' + (checkIndex !== -1 ? 'fa-check-square' : 'fa-square')}></i>
            <span className="checkBox-title">
              <Highlighter textToHighlight={obj.name} searchWords={searchTerm} />
            </span>
          </span>
        </div>
      );
    });
    return options.length ? (
      options
    ) : (
      <div role="alert" className="centerIt-Orgs verticle-middle">
        No Results. Please adjust your search and try again.
      </div>
    );
  }

  render() {
    const inputFields = this.props;
    const { required } = this.props;
    const error = inputFields.formSubmitted && inputFields.clientIdsSelected.length < inputFields.minRequired;
    const errorClass = error ? 'border-error' : null;
    const controlSize = layoutGridSize - formLabelSize;
    const controlSizeSm = layoutGridSize - formLabelSizeSm;
    return (
      <React.Fragment>
        <Row className="v-middle-align">
          <Label
            hidden={!!inputFields.block}
            for="selectOrganizations"
            xs={layoutGridSize}
            sm={formLabelSizeSm}
            md={formLabelSize}
            className="ScalaSansOT">
            {required ? <span className="lsn-red">*</span> : void 0}
            <span id="searchInputLabel">{inputFields.title}</span>
          </Label>
          <Col className="input-left relative" xs={layoutGridSize} sm={controlSizeSm} md={controlSize}>
            <input
              id="selectOrganizations"
              type="search"
              aria-describedby={['selectedOrganizationsInfo'].filter((v) => !!v).join(' ')}
              aria-labelledby={'searchInputLabel'}
              aria-invalid={error}
              className={['input', errorClass].filter((v) => !!v).join(' ')}
              placeholder={inputFields.placeholder}
              onChange={(evt) => this.setState({ searchTerm: evt.target.value })}
            />
            <span className="search-icon">
              <i className="fa fa-search"></i>
            </span>
          </Col>
        </Row>
        <Row>
          <Col
            md={inputFields.block ? null : { size: controlSize, offset: formLabelSize }}
            sm={inputFields.block ? null : { size: controlSizeSm, offset: formLabelSizeSm }}>
            <div className={['searchBoxContianer', errorClass].filter((v) => !!v).join(' ')}>
              <div hidden={this.props.busy} className="searchBoxList" role="group" aria-labelledby="searchInputLabel">
                {this.renderOptions(inputFields)}
              </div>
              <Loading show={this.props.busy} backdrop classNames={['loading-cas-orgs-checklist']} />
            </div>

            <Row className={[error ? 'mTop-5 mBottom-10 v-middle-align' : 'pYSm-5'].join(' ')}>
              <Col sm={layoutGridSize} md={layoutGridSize}>
                {error ? (
                  <span
                    id="errorSelectOrganizations"
                    className="input-error"
                    role="alert"
                    aria-describedby="selectOrganizations"
                    aria-label={`validation failed. ${inputFields.title}`}>
                    {inputFields.title}
                  </span>
                ) : (
                  void 0
                )}
              </Col>
            </Row>

            <div id="selectedOrganizationsInfo" aria-live="polite">
              {`${inputFields.clientIdsSelected.length} selected`}
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default SelectSearchChecboxOptions;
